module.exports = "/resources/js/eb1b49e5b395a59e9d220f2acfcca629.svg";